import { withStoreHeaders } from './storeHeaders.js';
import { getAuthToken } from '../Utils/authToken.js';

export const getAuthHeaders = (extraHeaders = {}) => {
    // Must go through getAuthToken(): the admin token lives under `quazbit_admin_token`,
    // and setAuthToken() deletes the legacy `token` key, so reading storage directly here
    // returned no Authorization header at all and every call 401'd.
    const token = getAuthToken();

    const authHeaders = token
        ? { Authorization: `Bearer ${token}` }
        : {};

    return {
        headers: withStoreHeaders({ ...authHeaders, ...extraHeaders })
    };
};
